"use client"

import type { MouseEvent } from "react"

import { ScanSearch } from "lucide-react"

import { trackEvent } from "@/lib/analytics"
import { IDENTIFY_CTA, identifyCtaProps } from "@/lib/identify-cta"
import { Stagger } from "@/components/motion"

export function MidPageCta() {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    trackEvent("cta_clicked", identifyCtaProps(IDENTIFY_CTA.location.homepageMid))
    document
      .getElementById("analysis-card")
      ?.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  return (
    <section className="bg-background px-7 py-12 md:py-16">
      <Stagger className="max-w-2xl mx-auto text-center">
        <Stagger.Item>
          <h2 className="font-bold tracking-[-0.02em] text-gray-900 mb-4 text-[28px] md:text-4xl">
            Saw enough? Find out what&apos;s growing.
          </h2>
        </Stagger.Item>
        <Stagger.Item>
          <p className="text-gray-600 leading-relaxed mb-6 text-base md:text-lg">
            It takes one photo and usually under 20 seconds
          </p>
        </Stagger.Item>
        <Stagger.Item>
          <a
            href="#analysis-card"
            onClick={handleClick}
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-10 py-4 rounded-xl bg-linear-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-semibold text-lg md:text-xl shadow-[0_12px_32px_rgb(22,163,74,0.28)] transition-[transform,box-shadow,background] duration-300 hover:scale-[1.02] active:scale-[0.98] min-h-[56px]"
          >
            <ScanSearch className="w-5 h-5" />
            {IDENTIFY_CTA.label}
          </a>
        </Stagger.Item>
        <Stagger.Item>
          <p className="mt-4 text-xs text-gray-500">
            Free · No credit card · Deleted after 30 days
          </p>
        </Stagger.Item>
      </Stagger>
    </section>
  )
}
